var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchMagnifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    color: "#5E639B",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0356L15.514 14.0231M18 8.66058C18 10.6734 17.1045 12.6037 15.5104 14.027C13.9163 15.4503 11.7543 16.2499 9.5 16.2499C7.24566 16.2499 5.08365 15.4503 3.48959 14.027C1.89553 12.6037 1 10.6734 1 8.66058C1 6.64777 1.89553 4.71741 3.48959 3.29414C5.08365 1.87087 7.24566 1.07129 9.5 1.07129C11.7543 1.07129 13.9163 1.87087 15.5104 3.29414C17.1045 4.71741 18 6.64777 18 8.66058Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagnifyIcon);
export default __webpack_public_path__ + "static/media/SearchMagnifyIcon.7384abda0685e8ee86e2ae979e20492b.svg";
export { ForwardRef as ReactComponent };